<template>
  <div>
    <loading :showLoading="load" />
    <grid
      class="grid"
      :title="$t('ConfigurationGrid.Title')"
      :headers="headers"
      controller
      readAll="POD/GetClientConfigurations"
      searchFields="ClientCode,OutFileName,TrafficType"
      :disableEdit="true"
      :disableDelete="true"
      :ExportExcel="false" 
      :ShowMenu="true" 
      :CanCreate="true"
      :CreateLabel="$t('ConfigurationGrid.newItem')"
      :CanDownload="false"
      :DownloadLabel="$t('ContextMenu.Download')"
      :externalFilters="this.$store.getters.GET_elementToSearchOfGridMenu"    
      createComponentRoute="ConfigEdit"
      :refresh="this.$store.getters.GET_reloadPage"
      :showFooter="false"
      :canExpand="false"
      :hideColumns="[ 'id', 'lastProcessingDate' ]"
      gridType="ClientConfiguration"
      
    >
      <template v-slot:default="child">
        <li @click="edit(child)" class="li-nobullets contextMenu">
          <span>{{ $t('ContextMenu.Edit') }}</span>
        </li>        
        <li @click="process(child)" class="li-nobullets contextMenu">          
          <span>{{ $t('ContextMenu.Process') }}</span>
        </li>        
      </template>
    </grid>

    <v-dialog v-model="dialog" width="500" persistent class="modalProcess">
      <div>
        <v-menu
            v-model="menuStartDate"
            :close-on-content-click="true"            
            transition="scale-transition"
            offset-y
            full-width
            :nudge-top="14"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="computedStartDateFormatted"
                append-icon="far fa-calendar-alt"
                readonly
                solo
                v-on="on"
                height="30"                
                :placeholder="$t('ContextMenu.StartDate')"
                @click:append="menuStartDate = true"
              ></v-text-field>
            </template>
            <v-date-picker v-model="startDate" color="#212121" @input="menuStartDate = false"></v-date-picker>
          </v-menu>
      </div>
      <div>
         <v-menu
                v-model="menuEndDate"
                :close-on-content-click="false"                
                transition="scale-transition"
                offset-y
                full-width
                :nudge-top="14"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedEndDateFormatted"
                    append-icon="far fa-calendar-alt"
                    readonly
                    solo
                    v-on="on"
                    height="30"
                    :placeholder="$t('ContextMenu.EndDate')"                    
                    @click:append="menuEndDate = true"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="endDate" color="#212121" @input="menuEndDate = false"></v-date-picker>
              </v-menu>
      </div>
      <div>        
          <v-btn
            class="white--text styleButtonTop styleAlignementSaveButton border"
            @click="submit()"
            color="black">
            <v-icon left>fas fa-check-circle</v-icon> 
            {{ $t("ContextMenu.Process") }}
          </v-btn>
          <v-btn class="styleButtonTop border" @click="closeDialog()">
            <v-icon left>fas fa-times-circle</v-icon>
            {{ $t("SearchMenu.Button.Cancel") }}
          </v-btn>
      </div>
    </v-dialog>
   
    <v-snackbar
      v-model="showErr"
      color="error"
    >
      {{ textErr }}
      <v-btn
        color="white"
        text
        @click="showErr=false">
        {{ $t("Misc.Close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import loading from "../../components/loadingComponent.vue";
import grid from "../../components/gridComponent.vue";
import preview from "../../components/previewComponent.vue";
import router from "@/router/index.js";
import { Trans } from "@/plugins/Translation";
import HyperstorageApi from "../../api/Hyperstorage/api.js";
import PODApi from "../../api/PODPortal/api.js";

export default {
  components: {
    loading,
    grid,
    preview
  },

  data() { 
    return {    
      ManageClientsFunction: process.env.VUE_APP_MANAGE_CLIENTS,
      load: false,
      refresh: false,      
      filters: {},
      dialog: false,      
      showErr: false,
      textErr: "",      
      ClientCode: "",
      FileName: "",
      isDachser: false,
      trafficType: "",
      menuStartDate: false,
      menuEndDate: false, 
      // startDate: new Date().toISOString().substr(0, 10),
      // startDateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      // endDate: new Date().toISOString().substr(0, 10),
      // endDateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      startDate: "",
      startDateFormatted: "",
      endDate: "",
      endDateFormatted: "",
      headers: [
        { text: Trans.i18n.t("grid.Columns.ClientCode"), value: "clientCode"},
        { text: Trans.i18n.t("grid.Columns.TrafficType"), value: "trafficType"},
        { text: Trans.i18n.t("grid.Columns.OutFileName"), value: "outFileName"},
        { text: Trans.i18n.t("grid.Columns.Status"), value: "status"},
        { text: Trans.i18n.t("grid.Columns.LastProcessingDate"), value: "lastProcessingDate_s"},
        { text: Trans.i18n.t("grid.Columns.CreationUser"), value: "creationUser"},
        { text: Trans.i18n.t("grid.Columns.LastModified"), value: "lastModified"},
        { text: Trans.i18n.t("grid.Columns.ModifiedUser"), value: "modifiedUser"}
      ],      
    };
  },

  watch: {
    menuStartDate: {
       handler(newVal) {
         //this.load = true;
       }
    },
    startDate(val) {
      this.startDateFormatted = this.formatDate(this.startDate);
    },
    endDate(val) {
      this.endDateFormatted = this.formatDate(this.endDate);
    }
  },

  computed: {
    computedStartDateFormatted() {
      return this.formatDate(this.startDate);
    },
    computedEndDateFormatted() {
      return this.formatDate(this.endDate);
    },
  },

  created() {
    
    if (!this.hasPermission()) {
       router.push({name: "Home"});
    }
    this.menuStart();
    this.filters = JSON.parse(
      localStorage.getItem(this.localStorageItemGridId)
    );
    this.$store.commit("SET_elementToSearchOfGridMenu", this.filters);
  },

  methods: {
    async hasPermission() {
      let result = await this.$GAUserAuth.canRead(this.ManageClientsFunction);
      return result;   
    },
    edit(child) {
      router.push({name: "ConfigEdit", params: { Id: child.child.data.name.id} });      
    },

    process(child) {
      this.ClientCode=child.child.data.name.clientCode;
      this.FileName=child.child.data.name.outFileName;
      this.isDachser=child.child.data.name.dachser;
      this.trafficType=child.child.data.name.trafficType;
      this.dialog=true;
    },

    closeDialog() {
      this.dialog=false;
      this.startDate=null;
      this.endDate=null;
    },

    submit() {
      if (new Date(this.startDate) > new Date(this.endDate) || !this.startDate) {        
        this.showErr=true;
        this.textErr=Trans.i18n.t("Validations.WrongSearchDates");        
        return;
      }

      var realEnd=this.endDate;
      
      if (!realEnd) {
        realEnd=this.getEndDateToFuture();
      }     

      this.load=true;


      var trafficTypes=[];
      if (this.trafficType.indexOf("I") > -1)
        trafficTypes.push("IMPORT")

      if (this.trafficType.indexOf("N") > -1)
        trafficTypes.push("NAZIONALE")

      if (this.trafficType.indexOf("E") > -1)
        trafficTypes.push("EXPORT")      
      

      let arg = {
        ClientCode: this.ClientCode,
        CreationDateStart: this.startDate,
        CreationDateEnd: realEnd,        
        isDachser: this.isDachser ? this.isDachser : false,
        TrafficType: trafficTypes
      };      

       HyperstorageApi.GetAllWithDachser(arg).then(response=>{
        if (response.data.length == 0)
        {
          this.showErr = true;
          this.textErr = "Nessun POD trovato per il periodo specificato"; 
          this.load = false;
          return;
        }

        let sendtoftparg= {
          FileName: this.FileName,
          pods: response.data
        }

        PODApi.SendToFtp(sendtoftparg).then(response=>{
        }).catch(e=>{
          this.showErr=true;
          this.textErr=e.response.data;          
        }).finally(()=>{
          this.load=false;
        })
      }).catch(e=>{
          this.showErr=true;
          this.textErr=e.response.data;          
      })

      this.dialog=false;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    menuStart() {
      let showSM = {
        show: false,
        style: "display: none;"
      };
      this.$store.commit("SET_showSearchMenu", showSM);
    },

    getEndDateToFuture() {
      var startDefaultDate = new Date(
        new Date().getFullYear() + 10,
        new Date().getMonth(),
        new Date().getDate() + 1
      );

      let d =
        startDefaultDate.getFullYear() +
        "-" +
        ("0" + (Number(startDefaultDate.getMonth()) + Number(1))).slice(-2) +
        "-" +
        ("0" + startDefaultDate.getDate()).slice(-2);

      return d;
    },
  }
}
</script>
